/**
 * @fileoverview Hook for submitting answers to the API
 *
 * @example
 * // Usage:
 * import { useSubmit } from './useSubmit'
 *
 * function Component() {
 *   const submit = useSubmit()
 *   // ...
 * }
 */

import axios, { AxiosResponse } from 'axios'

/**
 * @function useSubmit
 * @description Hook for submitting answers to the API
 * @returns {[function]} An array containing the submit function
 */
export function useSubmit<T extends Record<string, unknown>>(): [
    (arg0: Novoic.Answer<T>) => Promise<[Record<string, unknown>, number]>
] {
    async function onSubmit<T extends Record<string, unknown>>(
        payload: Novoic.Answer<T>
    ): Promise<[Record<string, unknown>, number]> {
        const { data, status } = await axios.post<
            Record<string, unknown>,
            AxiosResponse<Record<string, unknown>>
        >(`${process.env.API_HOST}`, {
            answer: payload.answer,
        })

        return [data, status]
    }

    return [onSubmit]
}
